module.exports = __webpack_public_path__ + "static/media/tornado.225d6a87.svg";